// extracted by mini-css-extract-plugin
module.exports = {"root":"style_root__AK0R_"};